var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-settings"},[_c('ProfileSettingsEmailNotifications'),_c('ProfileSettingsBrowserNotifications'),_c('ProfileSettingsCurrentSubscriptions',{on:{"subscribe":function($event){return _vm.subscribe()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }